import { render, staticRenderFns } from "./CustomActionPoints.vue?vue&type=template&id=7e4c77d8&scoped=true"
import script from "./CustomActionPoints.vue?vue&type=script&lang=js"
export * from "./CustomActionPoints.vue?vue&type=script&lang=js"
import style0 from "./CustomActionPoints.vue?vue&type=style&index=0&id=7e4c77d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4c77d8",
  null
  
)

export default component.exports